<template>
  <div id="evaluate">
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>商品管理&nbsp;/&nbsp;评价管理</span>
        </div>
        <div style="display: flex;flex-wrap: wrap;align-items: center;">
          <Provinces @gain='gainSS'></Provinces>
         <el-input class="elinputs" v-model="beginData.goodsName" placeholder="商品名称"></el-input>
          <el-select v-model="beginData.star" placeholder="商品评分" class="elinputs">
              <el-option v-for="item in beginData.stars" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
          </el-select>
          <el-select v-model="beginData.status" placeholder="审核状态" class="elinputs">
              <el-option v-for="item in beginData.statu" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
          </el-select>
          <el-date-picker style="margin-right:16px;" align="right" unlink-panels :picker-options="pickerOptions" v-model="beginData.value1" type="datetimerange" value-format="yyyy-MM-dd HH:mm" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间">
          </el-date-picker>
          <el-button type="primary" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
          <el-button type="info" @click='resets'>重置</el-button>
        </div>
        <div class="tit">
          <Reset @clkBtn='theBtn'></Reset>
          <Xlsx :name="formname"></Xlsx>
        </div>
        <el-table :data="tableData" id="exportTab" @selection-change="handleSelectionChange" border stripe style="width: 100%">
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
            <el-table-column prop="goodsName" label="商品名称" min-width="360"></el-table-column>
            <el-table-column label="商品缩略图" width="200">
                <template slot-scope="scope">
                    <viewer>
                        <img class="sfzimg" :src="imgUrl+scope.row.goodsImg" />
                    </viewer>
                </template>
            </el-table-column>
            <el-table-column prop="username" label="用户昵称" width="100"></el-table-column>
            <!-- <el-table-column label="用户地址" min-width="240">
                <template slot-scope="scope">
                    <p>{{scope.row.province}}{{scope.row.city}}{{scope.row.district}}{{scope.row.town}}{{scope.row.village}}</p>
                </template>
            </el-table-column> -->
            <el-table-column min-width="180" sortable label="商品评分">
                <template slot-scope="scope">
                    <el-rate v-model="scope.row.star" disabled text-color="#ff9900" score-template="{value}">
                    </el-rate>
                </template>
            </el-table-column>
            <el-table-column prop="content" label="评论内容" width="160" :show-overflow-tooltip="true"></el-table-column>

            <el-table-column label="评论状态" width="130">
                <template slot-scope="scope">
                    <p class="boldfont" v-if="scope.row.status==0" style="color:#F56C6C">待审核</p>
                    <p class="boldfont" v-if="scope.row.status==1" style="color:#67C23A">审核通过</p>
                    <p class="boldfont" v-if="scope.row.status==2" style="color:#E6A23C">审核不通过</p>
                </template>
            </el-table-column>
            <el-table-column prop="addTime" label="评论时间" width="180"></el-table-column>
            <el-table-column label="操作" fixed="right" min-width="200">
                <template slot-scope="scope">
                <el-button size="mini" type="success" @click="handleEdit(1,scope.row)"><i class="el-icon-edit"></i> 评论详情</el-button>
                <el-button size="mini" type="danger" @click="stop(scope.row,'evaluate:delete')"><i class="el-icon-delete"></i> 删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="paging">
            <span>
            共
            <i class="pagingNum">{{total}}</i> 条
            </span>
            <Paging :gopage="total" @pag="pag"></Paging>
        </div>
    </el-card>
    <el-dialog title="商品评价详情" :visible.sync="dialogFormVisible" width="60%" @close="dataClose">
        <el-form>
            <el-form-item label="* 商品编号：">
                <p>{{mydata.goodsSn}}</p>
            </el-form-item>
            <el-form-item label="* 商品名称：">
                <p>{{mydata.goodsName}}</p>
            </el-form-item>
            <el-form-item label="* 商品缩略图：">
                <viewer>
                    <img class="sfzimg" :src="imgUrl+mydata.goodsImg" />
                </viewer>
            </el-form-item>
            <el-form-item label="* 用户昵称：">
                <p>{{mydata.username}}</p>
            </el-form-item>
            <el-form-item label="* 商品评分：">
                <el-rate v-model="mydata.star" disabled text-color="#ff9900" score-template="{value}">
                </el-rate>
            </el-form-item>
            <el-form-item label="* 评论内容：">
                <p>{{mydata.content}}</p>
            </el-form-item>
            <el-form-item label="* 评论状态：">
                <p class="boldfont" v-if="mydata.status==0" style="color:#F56C6C">待审核</p>
                <p class="boldfont" v-if="mydata.status==1" style="color:#67C23A">审核通过</p>
                <p class="boldfont" v-if="mydata.status==2" style="color:#E6A23C">审核不通过</p>
            </el-form-item>
            <el-form-item label="* 评论图片：">
                <p v-if="!mydata.hasPicture" style="color:#F56C6C">暂无图片</p>
                <viewer v-else>
                    <img class="sfzimg" v-for="(item,index) in mydata.picUrls.split(',')" :key="index" :src="imgUrl+item" />
                </viewer>
            </el-form-item>
        </el-form>
        <div v-if="opbtn('evaluate:examine')" style="text-align: right;margin-top:20px">
          <div slot="footer" v-if="mydata.status==0" class="dialog-footer">
              <el-button @click="puton(1)">评价通过</el-button>
              <el-button type="primary" @click="puton(2)">评价不通过</el-button>
          </div>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import Xlsx from "@/components/Xlsx";
import EditorBar from '@/components/Richtext';
import Reset from "@/components/Reset";
import Paging from '@/components/Paging';
import Provinces from "@/components/Provinces";
export default {
  name: "evaluate",
  components: {
    Xlsx,
    EditorBar,
    Reset,
    Paging,
    Provinces
  },
  data() {
    return {
        beginData:{
            statu:[{id:0,name:'待审核'},{id:1,name:'审核通过'},{id:2,name:'审核不通过'}],
            value1:[],
            stars:[{id:1,name:'一星'},{id:2,name:'二星'},{id:3,name:'三星'},{id:4,name:'四星'},{id:5,name:'五星'}]
        },
        tableData: [],
        pageNum: 1,
        pageSize: 10,
        dialogFormVisible: false,
        userdata: {},
        total: 0,
        btn: [],
        fullscreenLoading: true,
        formname: JSON.stringify({name:'评价管理',hint:'evaluate:export'}),
        imgUrl: this.$Public.imgUrl,
        mydata:{},
        multipleSelection:[],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    }
  },
  mounted() {
    let region = JSON.parse(localStorage.getItem('region'))
  },
  methods: {
    resets(){
        this.$router.push('/refresh')
    },
    // 权限按钮
    opbtn(i){
        if(this.btn.indexOf(i)==-1){
            return false
        }else{
            return true
        }
    },
    //   判断当前点击的按钮
    theBtn(i){
        if(i==1){
            return this.$message('该列表暂无添加功能')
        }else if(i==2){
            if(this.multipleSelection.length != 1){
                return this.$message('请勾选一项内容编辑')
            }
            this.handleEdit(1,this.multipleSelection[0])
        }else if(i==3){
            if(this.btn.indexOf('evaluate:delete')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.choice()
        }else if(i==4){
            this.query()
        }
    },
    // 获取省市传入的id
    gainSS(i){
        this.beginData.areaId = i.name
    },
    //   多选删除
    choice(){
        if(this.multipleSelection.length == 0){
            return this.$message('请至少选择一项删除')
        }
        let arr = []
        this.multipleSelection.forEach(x=>{
            arr.push(x.id)
        })
        this.$confirm('此操作将删除选中内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let url = ``
            url = `/api-s/deleteComment/${arr.join(',')}`
            this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
            .then(res=>{
                if(res.data.success==true){
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    this.begin();
                }else{
                    alert(res.data.msg)
                }
            })
        }).catch(() => {
            return
        });
    },
    // 关闭清空内容
    dataClose(){
      this.mydata={}
    },
    //   多选编辑
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    //   确定
    puton(x){
        this.$confirm('确认审核该评价吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let url = ``
            url = `/api-s/examineComment`
            let data = this.$qs.stringify({
                id:this.mydata.id,
                status:x
            })
            this.$axios.post(url,data,{ headers: { accessToken: this.userdata.token }})
            .then(res=>{
                if(res.data.success==true){
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    this.dialogFormVisible = false
                    this.begin();
                }else{
                    alert(res.data.msg)
                }
            })
        }).catch(() => {
            return
        });
    },
    reset() {
      this.beginData = {
            statu:[{id:0,name:'待审核'},{id:1,name:'审核通过'},{id:2,name:'审核不通过'}],
            value1:[],
            stars:[{id:1,name:'一星'},{id:2,name:'二星'},{id:3,name:'三星'},{id:4,name:'四星'},{id:5,name:'五星'}]
        },
      this.begin();
    },
    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.begin()
    },
    begin() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        star:this.beginData.star,
        status:this.beginData.status,
        goodsName:this.beginData.goodsName,
        startTime:this.beginData.value1[0],
        endTime:this.beginData.value1[1],
        adminAreasId: userdata.areasId,
        areaId:this.beginData.areaId
      });
      this.$axios.post(`/api-s/getCommentList`, data, {headers: { accessToken: userdata.token }})
        .then(res => {
            this.fullscreenLoading = false;
            if(res.data.success){
                this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
                    this.$set(this, "tableData", res.data.pageInfo.list);
                });
                this.$set(this, "total", res.data.pageInfo.total);
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
            }else{
              this.$message(res.data.msg)
            }
        });
    },
    handleEdit(i,row) {
        this.mydata = row
        this.dialogFormVisible = true
    },
    // 删除优惠券
    stop(row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
      this.$confirm('此操作将删除该条内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let url = ``
          url = `/api-s/deleteComment/${row.id}`
          this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
          .then(res=>{
              if(res.data.success==true){
                  this.$message({
                      type: 'success',
                      message: res.data.msg
                  });
                  this.begin();
              }else{
                  alert(res.data.msg)
              }
          })
      }).catch(() => {
          return
      });
    },
    query() {
      this.fullscreenLoading = true;
      this.begin();
    }
  }
};
</script>
<style>
.w-e-toolbar{
  flex-wrap: wrap;
}
#evaluate .el-input__inner {
  margin: 10px 0;
}
#evaluate .el-menu.el-menu--horizontal{
  margin-bottom: 14px;
}
#evaluate .el-menu-item.is-active{
  background: none
}
#evaluate .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#evaluate .el-tag{
  margin-right: 12px;
}
#evaluate .el-select {
  /* margin: 0 8px; */
}
#evaluate .el-upload__tip {
    display: inline-block;
    margin-left: 14px;
}
.input-new-tag{
  width: 20%
}
#evaluate .el-upload-list--picture .el-upload-list__item {
    width: 44%;
    float: left;
    margin-right: 2%;
}
#evaluate .el-form-item__content {
    width: 80%;
}
#evaluate .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#evaluate .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#evaluate .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#evaluate .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#evaluate .el-dialog__body {
  height: 100%;
}
#evaluate .el-form-item{
    display: flex;
    align-items: center;
    margin-bottom:0
}
#evaluate .el-form-item__label{
    width: 150px;
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx{
      color: red;
    margin-left: 8px;
}
.summary>span:first-child{
    margin-right: 20px
}
.summary>span:first-child i{
    color:red
}
.summary>span:last-child i{
    color:green
}
.staimg{
    position: absolute;
    left: -26px;
    top: 10px;
    width: 18px;
}
.dtstat span{
    margin: 0 34px;
}
</style>
